module.exports = __webpack_public_path__ + "img/mid-century-modern.45cc184.png";